export function loadScript(src) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            return resolve() // déjà chargé
        }

        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.crossOrigin = 'anonymous'

        script.onload = () => resolve()
        script.onerror = () => reject(new Error(`Échec du chargement du script ${src}`))

        document.head.appendChild(script)
    })
}